import {PointerDownIcon} from "@hosttools/frontend";
import {
    Badge,
    BadgeText,
    Button,
    ButtonIcon,
    ButtonText,
    HStack,
    Pressable
} from "@hosttools/frontend/components";
import {type AccountType} from "@hosttools/frontend/models/account";
import {type FC, memo, useCallback} from "react";

import ConnectChannelItemLabel from "@/client/components/ConnectChannelItemLabel";

interface Props {
    accountType: AccountType;
    isDisabled?: boolean;
    onPress?: (type: AccountType) => void;
}

const ChannelItem: FC<Props> = ({accountType, isDisabled, onPress}) => {
    const handlePress = useCallback(() => {
        onPress?.(accountType);
    }, [accountType, onPress]);

    return (
        <Pressable onPress={handlePress}>
            <HStack
                className={`
                    flex flex-row justify-between p-3
                    border border-solid border-blueGray-200
                    rounded-lg
                `}
            >
                <HStack className="items-center" space="sm">
                    <ConnectChannelItemLabel accountType={accountType} />
                    {(accountType === "Airbnb" || accountType === "Houfy") && (
                        // the Badge component shouldn't set the text color based on the passed color scheme
                        <Badge action="info" variant="outline">
                            <BadgeText>Recommended</BadgeText>
                        </Badge>
                    )}
                </HStack>
                <Button
                    isDisabled={isDisabled}
                    testID={`btn-import-listings-${accountType}`}
                    variant="ghost"
                    onPress={handlePress}
                >
                    <ButtonIcon as={PointerDownIcon} />
                    <ButtonText>Import listings</ButtonText>
                </Button>
            </HStack>
        </Pressable>
    );
};

export default memo(ChannelItem);
